import chatbotRequest from '@/service/channel/http'
import type { SessionListReq, SessionListRes } from '../types/getSessionList'

export function getSessionListApi(data: SessionListReq): Promise<SessionListRes> {
    return chatbotRequest<SessionListRes, SessionListReq, SessionListRes>({
        url: '/api/history/session/list',
        method: 'post',
        data,
    })
}